export default class SearchQuery {
  queryStr: string;
  isSelected: boolean; // Flag to check if value is selected from the auto suggest dropdown

  constructor(queryStr: string, isSelected: boolean) {
    this.queryStr = queryStr;
    this.isSelected = isSelected;
  }
}
